import { render, staticRenderFns } from "./riderWiseOFDReport_KSA_new.vue?vue&type=template&id=2f8e446b&"
import script from "./riderWiseOFDReport_KSA_new.vue?vue&type=script&lang=js&"
export * from "./riderWiseOFDReport_KSA_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports